import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  // Close menu on route change
  useEffect(() => setOpen(false), [pathname]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (open) document.body.classList.add("menu-open");
    else document.body.classList.remove("menu-open");
    return () => document.body.classList.remove("menu-open");
  }, [open]);

  const Burger = () => (
    <button
      className={`burger ${open ? "burger-open" : ""}`}
      aria-label="Toggle navigation"
      aria-expanded={open}
      aria-controls="primary-nav"
      onClick={() => setOpen((v) => !v)}
    >
      <span />
      <span />
      <span />
    </button>
  );

  const HeroNavLinks = () => (
    <>
      <Link to="/" onClick={() => setOpen(false)}>Početna</Link>
      <Link to="/jobs-page" onClick={() => setOpen(false)}>Svi Poslovi</Link>
      <Link to="/fastApplication" onClick={() => setOpen(false)}>Brza Prijava</Link>
      <Link to="/create-cv" onClick={() => setOpen(false)}>Napravi CV</Link>
      <Link to="/about" onClick={() => setOpen(false)}>O nama</Link>   {/* ✅ New */}
    </>
  );

  if (isHome) {
    // === Your current HERO header stays the same ===
    return (
      <header className="hero-header">
        <div className="hero-overlay">
          <nav className="hero-navbar">
            <div className="nav-left">
              <Link to="/" className="logo-brand">
                <img src="../images/StarLogo.jpg" alt="Logo" className="logo-img" />
                <span className="logo-title">SEZONSKI POSLOVI STAR</span>
              </Link>
              <Burger />
            </div>

            <div id="primary-nav" className={`hero-links ${open ? "open" : ""}`}>
              <HeroNavLinks />
            </div>
          </nav>

          <div className="hero-content">
            <h1>Zdravo! Tražiš posao?</h1>
            <p>Na pravom si mjestu !</p>
          </div>

          {open && <div className="nav-overlay" onClick={() => setOpen(false)} />}
        </div>
      </header>
    );
  }

  // === Simple header (old look + old drawer behavior) ===
  return (
    <header className="simple-header">
      <div className="header">
        <Link to="/" className="header-brand" onClick={() => setOpen(false)}>
          <img src="../images/StarLogo.jpg" alt="Logo" className="header-logo" />
          <h1 className="header-title">SEZONSKI POSLOVI STAR</h1>
        </Link>

        <Burger />

        <nav
          id="primary-nav"
          className={`header-tabs ${open ? "open" : ""}`}
          role="navigation"
        >
          <Link to="/" className="header-link" onClick={() => setOpen(false)}>Početna</Link>
          <Link to="/jobs-page" className="header-link" onClick={() => setOpen(false)}>Svi Poslovi</Link>
          <Link to="/fastApplication" className="header-link" onClick={() => setOpen(false)}>Brza Prijava</Link>
          <Link to="/create-cv" className="header-link" onClick={() => setOpen(false)}>Napravi CV</Link>
          <Link to="/about" className="header-link" onClick={() => setOpen(false)}>O nama</Link>  {/* ✅ New */}
        </nav>

        {open && <div className="nav-overlay" onClick={() => setOpen(false)} />}
      </div>
    </header>
  );
};

export default Header;
